export const environment = {
  production: true,
  apiUrl: 'https://monitoring.dev.vmms.network/api/v1',
  apiUrlV4: 'https://monitoring.dev.vmms.network/api/v4',
  importUrl: 'https://dev.import.vmms.network',
};
